import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const anchor = (h) => (onHome ? h : `/${h}`);

  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#0B0F19]">
      <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-2.5">
          <span className="bg-white/95 rounded-xl px-2 py-1 flex items-center">
            <img src="/ivibes-cloud.png" alt="iVIBES logo" className="h-6 w-auto" />
          </span>
          <div>
            <p className="font-heading font-extrabold tracking-tight leading-none">
              <span className="text-cyan-400">i</span>VIBES <span className="text-slate-400 font-medium text-sm">Consulting</span>
            </p>
            <p className="text-[11px] text-slate-500 mt-1">Virtual Integrated Business and Entrepreneurship Solutions</p>
          </div>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-300">
          <a href={anchor("#how-it-works")} data-testid="footer-how-it-works-link" className="hover:text-cyan-300 transition-colors duration-200">How It Works</a>
          <a href={anchor("#solutions")} data-testid="footer-solutions-link" className="hover:text-cyan-300 transition-colors duration-200">Solutions</a>
          <a href={anchor("#about")} data-testid="footer-about-link" className="hover:text-cyan-300 transition-colors duration-200">About</a>
          <a href={anchor("#contact")} data-testid="footer-contact-link" className="hover:text-cyan-300 transition-colors duration-200">Contact</a>
          <Link to="/scorecard" data-testid="footer-scorecard-link" className="hover:text-cyan-300 transition-colors duration-200">Scorecard</Link>
        </nav>
      </div>
      <div className="border-t border-white/5 py-6 px-6 text-center text-xs text-slate-400 space-y-2.5">
        <p>
          <a href="mailto:ismail@ivibesconsulting.com" data-testid="footer-email-link" data-track="email_click_footer" className="text-slate-300 hover:text-cyan-300 transition-colors duration-200">
            ismail@ivibesconsulting.com
          </a>
        </p>
        <p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-cyan-300 transition-colors duration-200">Privacy Policy</Link>
          <span className="mx-2 text-slate-600">·</span>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-cyan-300 transition-colors duration-200">Terms of Service</Link>
        </p>
        <p>© {new Date().getFullYear()} iVIBES Consulting. All rights reserved.</p>
      </div>
    </footer>
  );
}
